import React from 'react';
import Row from '@amzn/meridian/row';
import Loader from '@amzn/meridian/loader';
import { useSelectedLp } from '@amzn/carrierlogistics-commons/dist/hooks/authorisation/index';
import Breadcrumb, { BreadcrumbGroup } from '@amzn/meridian/breadcrumb';
import { noop } from 'lodash';
import { css } from '@emotion/css';
import { FormattedMessage } from 'react-intl';
import Text from '@amzn/meridian/text';

const LpHeader = () => {
  const lpSelected = useSelectedLp();
  const showLoader = !lpSelected?.logisticsPartyName;
  return (
    <Row>
      {showLoader ? (
        <Loader size="medium" />
      ) : (
        <div
          className={css`
            padding: 1rem 2rem;
          `}
        >
          <BreadcrumbGroup>
            <Breadcrumb onClick={noop}>
              <span
                className={css`
                  cursor: initial;
                `}
              >
                <FormattedMessage id="carrier_selected" />
              </span>
            </Breadcrumb>
            <Breadcrumb onClick={noop}>{lpSelected.logisticsPartyName}</Breadcrumb>
          </BreadcrumbGroup>
        </div>
      )}
    </Row>
  );
};

export default LpHeader;
